import { Attachment } from '@mui/icons-material';
import { LinearProgress } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { messagingFileUpload } from '../../../../../services/services';
import { AttachmentInterface } from './ConversationComponent';

interface MessagingAttachmentInterface {
  attachment: AttachmentInterface;
  onRemove: (fileId?: string) => void;
  onUploadFinish: (fileId: string) => void;
}

const MessagingAttachment = ({ attachment, onRemove, onUploadFinish }: MessagingAttachmentInterface) => {
  const [progress, setProgress] = useState(0);

  const { t } = useTranslation();

  useEffect(() => {
    if (attachment.fileId) return;
    uploadFile();
  }, []);

  const uploadFile = async () => {
    if (attachment.size / 1000000 > 2) {
      toast.error(t('toasts:file-too-large'));
      onRemove();
      return;
    }
    try {
      const { data } = await messagingFileUpload(attachment, (_progress: any) => setProgress(_progress));
      onUploadFinish(data.fileId);
    } catch (error) {
      onRemove();
    }
  };

  return (
    <div className="grid place-items-center relative p-2">
      <p className="absolute -top-1 right-0 text-bold text-black z-10 cursor-pointer p-1" onClick={() => onRemove(attachment.fileId)}>
        x
      </p>
      <div className="w-full h-full flex flex-col items-center justify-center bg-slate-100 rounded p-4 relative">
        <Attachment />
        <p className="truncate w-24">{attachment.name}</p>
        {progress < 100 && progress > 0 && (
          <div className="w-full absolute -bottom-1">
            <LinearProgress value={progress} variant="determinate" />
          </div>
        )}
      </div>
    </div>
  );
};
export default MessagingAttachment;
